function addQueryForBeta() {
  const config = useRuntimeConfig()

  if (config.public.CONFIG_ENV === 'beta') {
    return {
      nuxt: 'true',
    }
  }
  return {}
}

export default defineNuxtPlugin(nuxtApp => {
  const locale = nuxtApp.$i18n.locale.value

  nuxtApp.provide('routerData', {
    index: () => {
      return {
        name: `index___${locale}`,
        query: Object.assign({}, addQueryForBeta()),
      }
    },
    regions_rid: (regionID, queryObj) => {
      let query = {}
      if (queryObj && typeof queryObj === 'object') {
        query = Object.assign({}, queryObj)
      }
      return {
        name: `regions-rid___${locale}`,
        params: {
          rid: regionID,
        },
        query: query,
      }
    },
    branches_id: bid => {
      return {
        name: `branches-id___${locale}`,
        params: {
          id: bid,
        },
        query: Object.assign({}, addQueryForBeta()),
      }
    },
    branches_id_funbook: bid => {
      return {
        name: `branches-id-funbook___${locale}`,
        params: {
          id: bid,
        },
        query: Object.assign({}, addQueryForBeta()),
      }
    },
    products_id: id => {
      return {
        name: `products-id___${locale}`,
        params: {
          id: id,
        },
        query: Object.assign({}, addQueryForBeta()),
      }
    },
    regions_rid_categories_id: (regionID, categoryID) => {
      return {
        name: `regions-rid-categories-id___${locale}`,
        params: {
          rid: regionID,
          id: categoryID,
        },
        query: Object.assign({}, addQueryForBeta()),
      }
    },
  })
})
